import classNames from "classnames";
import React from "react";
import { replaceWithUnicode } from "../shared/string";

export enum MainPageHeadingTheme {
  Dark,
  Normal
}

export interface MainPageHeadingProps {
  children?: string;
  margin?: string;
  padding?: string;
  theme?: MainPageHeadingTheme;
}

export const MainPageHeading = ({
  children,
  margin = "mb-8 lg:mb-24",
  padding = "px-4",
  theme = MainPageHeadingTheme.Normal
}: MainPageHeadingProps) => (
  <h1
    className={classNames("lg:text-brand-primary-70", margin, padding, {
      "text-brand-primary-50": theme === MainPageHeadingTheme.Normal,
      "text-brand-primary-20": theme === MainPageHeadingTheme.Dark
    })}
  >
    {replaceWithUnicode(children)}
  </h1>
);
